module.exports = __webpack_public_path__ + "img/slika68.56360aab.jpg";